import { clearState } from '../../redux/auth/slices/login';

export const responseInterceptor = (response) => {
  // Response Interceptor
  return response;
};

export const errorInterceptor = async (error) => {
  if (error.response.status === 401) {
    const { dispatch } = await import('../../redux');
    dispatch(clearState());
  }
};
